export enum MedewerkerType {
  ARTS = "ARTS",
  ASSISTENT = "ASSISTENT",
  WAARNEMEND_ASSISTENT = "WAARNEMEND_ASSISTENT",
  VOORBEREIDINGS_ASSISTENT = "VOORBEREIDINGS_ASSISTENT",
  PM = "PM",
  INPLANNER = "INPLANNER",
  MANAGER = "MANAGER",
  FINANCIELE_MANAGER = "FINANCIELE_MANAGER",
  //WETENSCHAPPELIJKE_MEDEWERKER niet voor nu
  ADMIN = "ADMIN",
  OVERIG = "OVERIG",
  // W5 webinars-basisdocument (2026-08-15); achteraan = DB-enumvolgorde.
  WEBINAR_MANAGER = "WEBINAR_MANAGER",
  // Radiologie-assistent (08-10-2026): vast bedrag per maand, geen uren.
  RADIOLOGIE_ASSISTENT = "RADIOLOGIE_ASSISTENT",
}

/** DossierNotitie.zichtbaarheid — PM-notities alleen voor PM/leiding (backend: domain/pm-notities.ts). */
export enum NotitieZichtbaarheid {
  TEAM = "TEAM",
  PM = "PM",
}

export enum PartijOrganisatieType {
  VERZEKERAAR = "VERZEKERAAR",
  BELANGENBEHARTIGER = "BELANGENBEHARTIGER",
  MEDISCH_ADVIES_BUREAU_BELANGENBEHARTIGER = "MEDISCH_ADVIES_BUREAU_BELANGENBEHARTIGER",
  MEDISCH_ADVIES_BUREAU_VERZEKERAAR = "MEDISCH_ADVIES_BUREAU_VERZEKERAAR",
  FACTUURAFHANDELAAR = "FACTUURAFHANDELAAR",
  RECHTBANK = "RECHTBANK",
  OVERIG = "OVERIG",
}

export enum DossierPartijRol {
  AANVRAGER = "AANVRAGER",
  WEDERPARTIJ = "WEDERPARTIJ",
  FACTUURPARTIJ = "FACTUURPARTIJ",
}

export enum ExpertiseType {
  WA = "WA",
  ONG = "ONG",
  AO = "AO",
  KGO = "KGO", // klein gericht onderzoek
  BA = "BA", // beroepsaansprakelijkheid
  SE = "SE", // schriftelijke expertise
  SO = "SO", // second opinion
  OVERIG = "OVERIG",
}

export enum DossierStatus {
  ACTIEF = "ACTIEF",
  VOLTOOID = "VOLTOOID",
  GEANNULEERD = "GEANNULEERD",
}

export enum ProductType {
  AANVULLEND_ONDERZOEK = "AANVULLEND_ONDERZOEK",
  AANVULLENDE_VRAGEN = "AANVULLENDE_VRAGEN",
  TIJD = "TIJD",
  TOESLAG = "TOESLAG",
  STANDAARD_TOESLAG = "STANDAARD_TOESLAG",
  OVERIG = "OVERIG",
}

export enum Geslacht {
  MAN = "MAN",
  VROUW = "VROUW",
  OVERIG = "OVERIG",
}

export enum ProductEenheid {
  UUR = "UUR",
  STUKS = "STUKS",
  PAGINA = "PAGINA",
  OVERIG = "OVERIG",
}

export enum ProductPrijsType {
  OPBRENGST = "OPBRENGST",
  KOSTEN = "KOSTEN",
}

export enum ContactType {
  EMAIL = "EMAIL",
  EMAIL_FACTUUR = "EMAIL_FACTUUR",
  EMAIL_RAPPORT = "EMAIL_RAPPORT",
  EMAIL_KANTOOR = "EMAIL_KANTOOR",
  TELEFOONNUMMER_KANTOOR = "TELEFOONNUMMER_KANTOOR",
  TELEFOONNUMMER_MOBIEL = "TELEFOONNUMMER_MOBIEL",
  TELEFOONNUMMER_THUIS = "TELEFOONNUMMER_THUIS",
  LINKEDIN = "LINKEDIN",
  WEBSITELINK = "WEBSITELINK",
  FAX = "FAX",
  WHATSAPP = "WHATSAPP",
  INSTAGRAM = "INSTAGRAM",
  FACEBOOK = "FACEBOOK",
  X = "X",
  TELEGRAM = "TELEGRAM",
  SKYPE = "SKYPE",
  TEAMS = "TEAMS",
  OVERIG = "OVERIG",
}

export enum TijdlijnTaakType {
  AANTEKENINGEN_EN_RADIOLOGIE_AANVRAAG = "AANTEKENINGEN_EN_RADIOLOGIE_AANVRAAG",
  BEVESTIGEN_OG = "BEVESTIGEN_OG",
  UITNODIGEN_BETROKKENE = "UITNODIGEN_BETROKKENE",
  VOORBEREIDEN_PM = "VOORBEREIDEN_PM",
  VOORBEREIDEN_ASSISTENT = "VOORBEREIDEN_ASSISTENT",
  UITWERKEN_RAPPORT = "UITWERKEN_RAPPORT",
  VERSTUREN_CONCEPTRAPPORT_BETROKKENE = "VERSTUREN_CONCEPTRAPPORT_BETROKKENE",
  VERWERKEN_REACTIE_BETROKKENE = "VERWERKEN_REACTIE_BETROKKENE",
  VERSTUREN_CONCEPTRAPPORT_OG = "VERSTUREN_CONCEPTRAPPORT_OG",
  VERSTUREN_FACTUUR = "VERSTUREN_FACTUUR",
  VERWERKEN_REACTIE_OG = "VERWERKEN_REACTIE_OG",
  AANVULLENDE_VRAGEN_UITWERKEN = "AANVULLENDE_VRAGEN_UITWERKEN",
  VERSTUREN_DEFINITIEF_RAPPORT = "VERSTUREN_DEFINITIEF_RAPPORT",
  VERSTUREN_AANVULLENDE_FACTUUR = "VERSTUREN_AANVULLENDE_FACTUUR",
  ON_HOLD = "ON_HOLD",
  OVERIG = "OVERIG", //met comments
}

export enum TijdlijnDatumType {
  AANVRAAG_ONTVANGEN = "AANVRAAG_ONTVANGEN",
  ONDERZOEK = "ONDERZOEK",
  VERSTUURD_AAN_BETROKKENE = "VERSTUURD_AAN_BETROKKENE",
  VERSTUURD_AAN_OG = "VERSTUURD_AAN_OG",
  VERSTUURD_DEFINITIEF_RAPPORT = "VERSTUURD_DEFINITIEF_RAPPORT",
}

export enum TijdlijnItemType {
  DATUM = "DATUM", // Mijlpalen
  TAAK = "TAAK", // Interne taken
  WACHTEN = "WACHTEN", // Externe wachtrijen
}

export enum TijdlijnWachtType {
  ZIEKENHUIS = "ZIEKENHUIS",
  BETROKKENE = "BETROKKENE",
  OPDRACHTGEVER = "OPDRACHTGEVER",
  OVERIG = "OVERIG",
}

export enum AssistentAanwezig {
  Fysiek = "Fysiek",
  Online = "Online",
  Afwezig = "Afwezig",
}

// Facturatie enums
export enum FactuurType {
  HOOFD = "HOOFD",
  AANVULLEND = "AANVULLEND",
}

export enum FactuurStatus {
  NOG_NIET_VERSTUREN = "NOG_NIET_VERSTUREN",
  KLAAR_OM_TE_VERSTUREN = "KLAAR_OM_TE_VERSTUREN",
  VERSTUURD = "VERSTUURD",
  BETAALD = "BETAALD",
}

/** Medewerker.pdfOpenenVia (D9, I18): hoe een pdf op een Mac opent. */
export enum PdfOpenenVia {
  ONEDRIVE = "ONEDRIVE",
  BROWSER = "BROWSER",
}
